/**
 * HTML "sicuro" per testi che arrivano dal backend ma contengono dati di terzi
 * (es. titoli delle notifiche con nomi prodotto dai marketplace).
 * Tutto viene prima convertito in testo, poi si ripristinano solo i tag di
 * formattazione senza attributi: niente script, eventi on* o link.
 */
const TAG_CONSENTITI = ['b', 'strong', 'i', 'em', 'br'];

export const safeHtml = value => {
	if (value === undefined || value === null) return '';
	const escaped = String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	const tags = TAG_CONSENTITI.join('|');
	return escaped.replace(new RegExp(`&lt;(\\/?)(${tags})\\s*\\/?&gt;`, 'gi'), (match, chiusura, tag) => `<${chiusura}${tag.toLowerCase()}>`);
};

/**
 * Link da usare in un href: solo http(s) o percorsi relativi, mai javascript:/data:.
 * @return {string|null} null se il link non e' sicuro
 */
export const safeUrl = value => {
	if (typeof value !== 'string' || !value.trim()) return null;
	const url = value.trim();
	if (url.startsWith('/') && !url.startsWith('//')) return url;
	try {
		const parsed = new URL(url);
		return ['http:', 'https:'].includes(parsed.protocol) ? url : null;
	} catch (e) {
		return null;
	}
};

/**
 * Percorso interno del BO (es. "/ecommerce/loyalty/requests"): si apre con il router,
 * non come link esterno. Gli URL assoluti (download firmati, ...) danno null.
 * @param {string} value
 * @return {string|null}
 */
export const internalPath = value => {
	const url = safeUrl(value);
	return url && url.startsWith('/') ? url : null;
};

export default safeHtml;
